import React, { useState, useEffect } from "react";

import {
    Button,
    colors,
    Container,
    Grid,
    makeStyles,
    Paper,
    Typography,
} from "@material-ui/core";

import { uri } from "../../../../../help/Api";

import { useHistory } from "react-router-dom";
import {
    useStylesHed,
    useStylesSpDial,
    useStylesUiElemment,
} from "../../../../../St/comps/UseStyle";
import { insh as inshst } from "../../../../../Context/InshSt";
import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";

import ItemsDetailsTable from "./ItemsDetailsTable";
import { sto } from "../../../../../Context/InshData";
import useFetchURL from "../../../../../components/Hooks/useFetchURL";
import ItemsDetailsFilter from "./ItemsDetailsFilter";

const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        backgroundColor: colors.green[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: colors.blue[50],
        borderColor: colors.blue[300],
    },
}));

export default function ItemsDetails(props) {
    const { rptParams, setRptParams, isPurches, isStock, isMake,curr_id } = props;
    const { t } = useTranslation(["forms", "translation"]);


    const { data, fetching, fetchURL } = useFetchURL({
        ...{
            url:
                uri +
                `RptSafes/ItemsDetails?branch=${sto.branchi}
        &&safe=${rptParams.safe}
        &&curr_id=${curr_id}
        &&center=${-1}
        &&doc_type=${rptParams.doc_type}
        &&dateF=${rptParams.dateFrom}
        &&dateT=${rptParams.dateTo}&&typeMount=${0}&&price=${null}`,
            dependencyArray: [rptParams],
        },
    });


    const classes = useStyles();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();

    const his = useHistory();
    const type_doc = [
        { id: '02', name: "مبيعات" },
        { id: '01', name: "مشتريات" },
        { id: '11', name: "مرتجع مشتريات" },
        { id: '12', name: "مرتجع مبيعات" },
        { id: '22', name:"مخزون اول مدة" },
        { id: '23', name: "توريد مخزني" },
        { id: '24', name: "صرف مخزني" },
      ];
    return (
        <div className={classes.root}>
            <Typography
                component="div"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
            >
                <br />
                <Container
                    component={Paper}
                    maxWidth={false}
                    style={{
                        padding: "10px",
                    }}
                >
                    <Grid container justifyContent="center" spacing={1}>
                       <Grid
                            cont ainer
                            justifyContent="center"
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            spacing={1}
                        >
                            <ItemsDetailsFilter
                                {...{
                                    rptParams, setRptParams, isPurches, isStock, isMake,type_doc,
                                }}
                            />
                        </Grid>

                        <Grid item container justifyContent="center" xs={12}>
                            <BeatLoader loading={fetching} color={colors.green[300]} />
                            {!fetching && (
                                <ItemsDetailsTable
                                    {...{
                                        data: data?.itemsDetails ? data.itemsDetails : [],
                                        isPurches, isStock, isMake,
                                    }}
                                />
                            )}
                        </Grid>
                    </Grid>
                </Container>
            </Typography>
        </div>

    );
}
